<template>
  <!-- <div :class="['ds-page', { 'readonly-pagee': isReadonlyPage }]"> -->
  <div class="ds-page">
    <div class="row">
      <div class="col-lg-12">
        <div class="row row-deck row-cards mb-3"></div>
        <div class="row row-deck mb-4">
          <div class="col-md-6">
            <div class="card shadow-sm border-0 rounded-lg">
              <div class="card-body d-flex flex-column p-4">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h4 class="font-weight-bold mb-0">Effective Date</h4>
                  <b-badge pill variant="light" class="text-primary px-2 py-1">Mandatory</b-badge>
                </div>
                <div class="bg-light p-3 rounded mb-auto">
                  <b-form-group label="Start Date" class="small font-weight-bold">
                    <el-date-picker
                      v-model="form.new_features.effective_date.start_date"
                      v-if="form?.new_features?.effective_date?.start_date"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="Select date"
                      class="w-100"
                    />
                    <el-date-picker
                      v-else
                      v-model="form.start_date"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="Select date"
                      class="w-100"
                    />
                  </b-form-group>
                  <b-form-group label="End Date" class="small font-weight-bold mb-0">
                    <el-date-picker
                      v-model="form.new_features.effective_date.end_date"
                      v-if="form?.new_features?.effective_date?.end_date"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="Select date"
                      class="w-100"
                    />
                    <el-date-picker
                      v-else
                      v-model="form.end_date"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="Select date"
                      class="w-100"
                    />
                  </b-form-group>
                </div>
                <div class="text-right mt-3 pt-3 border-top">
                  <el-button
                    @click="doUpdateEffectiveDate()"
                    size="small"
                    type="primary"
                    class="w-20"
                    >Submit</el-button
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card shadow-sm border-0 rounded-lg">
              <div class="card-body d-flex flex-column p-4">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h4 class="font-weight-bold mb-0">Payroll Date</h4>
                  <b-badge pill variant="light" class="text-primary px-2 py-1">Mandatory</b-badge>
                </div>
                <div class="bg-light p-3 rounded mb-auto">
                  <b-form-group label="Cut Off Date" class="small font-weight-bold">
                    <el-select
                      size="small"
                      v-model="form.payoff_date"
                      placeholder="Select date"
                      class="w-100"
                    >
                      <el-option
                        v-for="option in options"
                        :value="option"
                        :label="option"
                        :key="option"
                      />
                    </el-select>
                  </b-form-group>
                  <b-form-group label="Payroll Date" class="small font-weight-bold mb-0">
                    <el-select
                      size="small"
                      v-model="form.payroll_date"
                      placeholder="Select date"
                      class="w-100"
                    >
                      <el-option
                        v-for="option in options"
                        :value="option"
                        :label="option"
                        :key="option"
                      />
                    </el-select>
                  </b-form-group>
                </div>
                <div class="text-right mt-3 pt-3 border-top">
                  <el-button @click="doUpdatePayrollDate()" size="small" type="primary" class="w-20"
                    >Submit</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row row-deck mb-4">
          <div class="col-md-12">
            <div class="card shadow-sm border-0 rounded-lg h-100">
              <div class="card-body d-flex flex-column p-4">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h4 class="font-weight-bold mb-0">Limit Company & Usage Settings</h4>
                  <b-badge
                    pill
                    variant="light"
                    class="text-primary px-2 py-1"
                    @click="OpenModalChart"
                    >Detail
                    <a class="btn btn-link btn-sm p-0 cursor-pointer">
                      <font-awesome-icon class="text-primary" :icon="'eye'" />
                    </a>
                  </b-badge>
                </div>

                <div class="bg-light p-3 rounded mb-auto">
                  <div class="row">
                    <div class="col-12 mb-3">
                      <b-form-group label="Process Flow" class="small font-weight-bold mb-0">
                        <el-radio-group v-model="form.company_policy.is_fast_track" size="small">
                          <el-radio class="text-dark" :label="true">Fast Track</el-radio>
                          <el-radio :label="false">Standard</el-radio>
                        </el-radio-group>
                      </b-form-group>
                    </div>
                    <div class="col-12 mb-2">
                      <b-form-group
                        label="Total payroll expense"
                        class="small font-weight-bold mb-0"
                      >
                        <el-input
                          size="small"
                          type="number"
                          v-model="form.company_policy.max_balance_disbursement"
                          placeholder="Input Limit Company Amount"
                        />
                      </b-form-group>
                    </div>

                    <div class="col-12 mb-2">
                      <b-form-group label="Limit Company" class="small font-weight-bold mb-0">
                        <el-input
                          size="small"
                          type="number"
                          @input="handlePercentageInput"
                          v-model.number="form.company_policy.salary_burden_percentage"
                          placeholder="e.g. 50"
                          :min="0"
                          :max="100"
                        >
                          <template slot="append">%</template>
                        </el-input>
                      </b-form-group>
                    </div>
                    <div class="col-12 mb-3">
                      <div
                        class="p-3 rounded d-flex align-items-center"
                        style="background-color: #e8f1ff; border: 1px solid #b6d4fe"
                      >
                        <font-awesome-icon icon="info-circle" class="text-primary mr-2" />
                        <span class="medium font-weight-bold text-dark">
                          {{
                            formatCurrency(
                              form.company_policy.max_balance_disbursement *
                                (form.company_policy.salary_burden_percentage / 100)
                            )
                          }}
                          <span class="text-muted font-weight-normal">
                            ({{ form.company_policy.salary_burden_percentage }}% of
                            {{ formatCurrency(form.company_policy.max_balance_disbursement) }})
                          </span>
                        </span>
                      </div>
                    </div>

                    <div class="col-12 mb-2">
                      <b-form-group label="PKS Number" class="small font-weight-bold mb-0">
                        <el-input
                          size="small"
                          v-model="formattedPksNumber"
                          placeholder="e.g. PKS-001/VNT/2026"
                        />
                      </b-form-group>
                    </div>

                    <div class="col-12 mb-3">
                      <b-form-group label="PKS Document" class="small font-weight-bold mb-0">
                        <b-form-file
                          v-model="form.upload.image"
                          :state="Boolean(form.upload.image)"
                          class="mt-2 border-1 p-2"
                          accept=".pdf, .csv"
                          @input="onChangeFile($event, 'image')"
                          placeholder="Choose a file or drop it here..."
                          drop-placeholder="Drop file here..."
                        ></b-form-file>
                        <br />
                        <div
                          v-if="formattedDocumentPksNumber"
                          class="mt-3 p-3 bg-light rounded-xl border"
                        >
                          <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                              <div class="bg-primary-subtle p-2 rounded-lg mr-3">
                                <font-awesome-icon
                                  icon="file-pdf"
                                  class="text-primary"
                                  style="font-size: 20px"
                                />
                              </div>
                              <div>
                                <p class="mb-0 text-muted small">Current Document</p>
                                <a
                                  :href="form.company_policy.pks_info.document_url"
                                  target="_blank"
                                  class="font-weight-bold text-primary text-decoration-none"
                                >
                                  View PKS Document
                                  <font-awesome-icon icon="external-link-alt" class="ml-1 small" />
                                </a>
                              </div>
                            </div>

                            <b-badge pill variant="success" class="px-3 py-2">Uploaded</b-badge>
                          </div>
                        </div>

                        <div v-else class="mt-2 small text-muted italic">
                          <font-awesome-icon icon="info-circle" class="mr-1" /> No document uploaded
                          yet.
                        </div>
                      </b-form-group>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between pt-2 border-top">
                    <div class="small">
                      <div class="text-muted">Total Employees</div>
                      <div class="font-weight-bold">{{ total_employee }}</div>
                    </div>
                    <div class="small text-right">
                      <div class="text-muted">Total Salary</div>
                      <div class="font-weight-bold text-success">{{ formattedTotalSalary }}</div>
                    </div>
                  </div>
                </div>

                <div class="text-right mt-3 pt-3 border-top">
                  <el-button @click="doUpdatePolicy()" size="small" type="primary" class="px-4">
                    Submit
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="product-features-wrapper mt-4"
          :class="{ 'is-locked': !isAllMandatoryFilled || !isCodeMandatoryFilled }"
        >
          <div>
            <div v-if="!isAllMandatoryFilled" class="lock-overlay">
              <div
                class="lock-message shadow-md text-center p-4 rounded-2xl bg-white/80 backdrop-blur-sm border border-amber-100 max-w-md mx-auto my-4 transition-all duration-300 hover:shadow-lg"
              >
                <div
                  class="inline-flex items-center justify-center w-12 h-12 rounded-full bg-amber-50 text-amber-500 mb-3 animate-pulse"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                    />
                  </svg>
                </div>

                <h5 class="font-extrabold text-gray-800 tracking-wide text-sm mb-2 uppercase">
                  Product Features Locked
                </h5>

                <p class="text-gray-500 small leading-relaxed mb-0">
                  Please complete and update
                  <span class="font-semibold text-danger-600">Effective Date</span>,
                  <span class="font-semibold text-danger-600">Payroll Date</span>, and
                  <span class="font-semibold text-danger-600">Company Limit</span> above to unlock
                  these settings.
                </p>
              </div>
            </div>
            <div v-else-if="!timerActive" class="lock-overlay">
              <div class="lock-message shadow-lg text-center">
                <font-awesome-icon icon="lock" class="text-danger mb-3" style="font-size: 32px" />

                <div class="w-100 px-4 mb-2">
                  <b-form-group label="" class="text-left small font-weight-bold">
                    <div class="d-flex justify-content-center align-items-center w-100">
                      <br /><br />
                      <div class="card-title text-center">Activate Two-Factor Authentication</div>
                    </div>

                    <div class="d-flex justify-content-center align-items-center">
                      <div class="card-body text-center">
                        <ol v-if="is_head_verified" class="text-center" style="list-style: auto">
                          <span class="mb-3 text-center block">
                            Please ask for the <b>Security QR Code</b> that has been
                            <b>sent to your Head</b>. <br />
                          </span>
                          Enter the authentication code to activate Two-Factor Authentication.
                          <div class="flex justify-between gap-2 mb-8 mt-2">
                            <input
                              v-for="(digit, index) in 6"
                              :key="index"
                              :ref="'otp' + index"
                              v-model="otpArray[index]"
                              type="text"
                              maxlength="1"
                              class="w-12 h-14 text-center text-xl font-bold bg-slate-50 border-2 border-slate-100 rounded-2xl focus:border-primary-500 focus:bg-white focus:ring-4 focus:ring-blue-100 outline-none transition-all"
                              placeholder="·"
                              @input="handleOtpInput($event, index)"
                              @keydown.delete="handleOtpDelete($event, index)"
                            />
                          </div>
                          <el-button
                            @click="onSubmit"
                            :loading="loading.submit"
                            size="small"
                            class="rounded-lg w-full mt-2"
                            type="primary"
                          >
                            Verify and Continue
                          </el-button>
                        </ol>

                        <div v-else class="py-4 text-center">
                          <p class="text-base text-gray-700 font-medium mb-2">
                            You need to do activation on your profile.
                          </p>
                          <span class="text-xs text-gray-500">
                            Please contact your supervisor or visit your profile settings to request
                            head verification.
                          </span>
                        </div>
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
          <div class="card shadow-sm border-0 rounded-lg">
            <div class="card-body p-4">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <h4 class="mb-0 font-weight-bold text-dark">Product Features</h4>
                  <p class="text-danger small">
                    <i>The product features will be locked in {{ formattedTime }}</i>
                  </p>
                  <small class="text-muted" v-if="!isAllMandatoryFilled"
                    >Action required to enable configuration</small
                  >
                </div>
                <a class="btn btn-link btn-sm p-0 cursor-pointer" @click="OpenModalProductFeatures">
                  <font-awesome-icon class="text-primary" :icon="'eye'" />
                </a>
              </div>
              <hr />

              <div style="overflow-x: auto">
                <el-table
                  :data="rowTypes"
                  class="ds-text-sm ds-text-muted"
                  style="min-width: 800px"
                >
                  <el-table-column prop="label" label="Feature Name" width="200" fixed />

                  <el-table-column
                    v-for="feature in filteredProductFeatures"
                    :key="feature.name"
                    :label="feature.name.toUpperCase()"
                    min-width="240"
                    class="ds-amount"
                  >
                    <template #default="{ row }">
                      <el-switch
                        v-if="row.type === 'enabled'"
                        v-model="feature.active"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="Yes"
                        inactive-text="No"
                        @change="processFeatureToggleLogic(feature)"
                      />
                      <!-- handleFeatureToggle -->
                      <el-select
                        v-else-if="row.type === 'early_repayment' && shouldShowAwav2(feature)"
                        v-model="feature.early_repayment.type"
                        size="small"
                        class="w-100"
                      >
                        <el-option
                          v-for="o in early_repayment_type_options"
                          :key="o.value"
                          :label="o.label"
                          :value="o.value"
                        />
                      </el-select>

                      <el-select
                        v-else-if="row.type === 'deduction_type' && shouldShowAwav2(feature)"
                        v-model="deductionTypeModel"
                        size="small"
                        class="w-100"
                      >
                        <el-option
                          v-for="o in deduction_type_options"
                          :key="o.value"
                          :label="o.label"
                          :value="o.value"
                        />
                      </el-select>
                      <el-input
                        v-else-if="row.type === 'minimum_request' && shouldShowMinimumReq(feature)"
                        v-model.number="feature.minimum_request"
                        type="number"
                        size="small"
                        class="w-100"
                      />

                      <el-select
                        v-else-if="row.type === 'type' && shouldShowAwav2(feature)"
                        v-model="feature.admin_fee.type"
                        size="small"
                        class="w-100"
                      >
                        <el-option
                          v-for="o in admin_fee_type_options"
                          :key="o.value"
                          :label="o.label"
                          :value="o.value"
                        />
                      </el-select>

                      <el-input
                        v-else-if="row.type === 'max_percentage' && shouldShowMP(feature)"
                        v-model.number="feature.max_percentage"
                        type="number"
                        size="small"
                      />

                      <el-input
                        v-else-if="row.type === 'ewa_limit' && shouldShowLimit(feature)"
                        v-model.number="feature.ewa_limit"
                        type="number"
                        size="small"
                      />

                      <template v-else-if="row.type === 'admin_fee'">
                        <div v-if="shouldShowAF(feature)">
                          <el-input
                            v-model.number="feature.admin_fee.base_percentage"
                            type="number"
                            size="small"
                            @blur="handleAdminFeeBlurr(feature)"
                          />
                        </div>
                        <div v-else-if="shouldShowLimit(feature)">
                          <el-input
                            v-model.number="feature.admin_fee_ewa"
                            type="number"
                            size="small"
                            @blur="handleAdminFeeBlurr(feature)"
                          />
                        </div>
                      </template>

                      <el-input
                        v-else-if="
                          form.company_policy.is_fast_track &&
                          row.type === 'min_fee' &&
                          shouldShowMinFee(feature)
                        "
                        v-model.number="feature.admin_fee.min_fee"
                        type="number"
                        size="small"
                        @blur="handleMinFeeBlur(feature)"
                      />
                      <el-select
                        v-else-if="row.type === 'tenor' && shouldShowTenor(feature)"
                        v-model="feature.repayment_terms"
                        multiple
                        size="small"
                        class="w-100"
                      >
                        <el-option
                          v-for="o in tenor_options"
                          :key="o.value"
                          :label="o.label"
                          :value="o.value"
                        />
                      </el-select>

                      <span v-else class="text-light">-</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div class="text-right mt-3 pt-3 border-top">
                <el-button
                  @click="doUpdateProductSetting()"
                  size="small"
                  type="primary"
                  class="px-5 shadow-sm"
                  :disabled="!isAllMandatoryFilled"
                >
                  Submit
                </el-button>
              </div>
            </div>
          </div>

          <el-dialog
            :visible.sync="contractNumberModal"
            @close="cancelCN()"
            title="Input Contract Number"
            width="30%"
          >
            <el-form label-width="100px">
              <el-form-item label="No. PKS" required>
                <el-input
                  class="mb-2"
                  v-model.trim="modal.contactNumber"
                  placeholder="Input PKS Number"
                ></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancelCN()" size="small">Cancel</el-button>
              <el-button @click="submitCN()" type="primary" size="small">Submit</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
      <b-modal
        size="lg"
        v-model="showModalEffectiveDate"
        title="History Effective Date"
        hide-footer
      >
        <div class="card-body">
          <el-timeline>
            <el-timeline-item timestamp="Effective date updated" color="#13ce66" placement="top">
              <el-card shadow="never">
                <p>
                  <strong>Owned By:</strong>
                  {{ form.new_features?.effective_date?.updated_by?.owned_by }}
                </p>
                <p>
                  <strong>Phone:</strong>
                  {{ form.new_features?.effective_date?.updated_by?.phone_number }}
                </p>
                <p>
                  <strong>Role ID:</strong>
                  {{ form.new_features?.effective_date?.updated_by?.role_id }}
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </b-modal>

      <b-modal size="lg" v-model="showModalCompanyLimit" title="History Company Limit" hide-footer>
        <div class="card-body">
          <el-timeline>
            <el-timeline-item timestamp="Company policy updated" color="#f1c40f" placement="top">
              <el-card shadow="never">
                <p><strong>Owned By:</strong> {{ setting_policy?.owned_by }}</p>
                <p><strong>Phone:</strong> {{ setting_policy?.phone_number }}</p>
                <p><strong>Role ID:</strong> {{ setting_policy?.role_id }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </b-modal>

      <b-modal
        size="lg"
        v-model="showModalProductFeatures"
        title="History Product Features"
        hide-footer
      >
        <div class="card-body">
          <el-timeline>
            <el-timeline-item timestamp="Product features updated" color="#13ce66" placement="top">
              <el-card shadow="never">
                <p>
                  <strong>Owned By:</strong>
                  {{ form.new_features?.company_policy?.updated_by?.owned_by }}
                </p>
                <p>
                  <strong>Phone:</strong>
                  {{ form.new_features?.company_policy?.updated_by?.phone_number }}
                </p>
                <p>
                  <strong>Role ID:</strong>
                  {{ form.new_features?.company_policy?.updated_by?.role_id }}
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </b-modal>
      <b-modal size="xl" v-model="showModalChart" title="Company Usage" hide-footer>
        <div class="card-body">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix card-header">
              <div class="header-title">
                <i class="el-icon-data-analysis icon-title"></i>
                <span>Ringkasan Limit Kredit & Visualisasi Status Pengajuan</span>
              </div>
            </div>

            <div class="usage-progress-section">
              <div class="progress-info">
                <span class="label">Disbursement Utilization</span>
                <span class="value font-bold"
                  >{{ responseData.disbursement_utilization_percentage }}%</span
                >
              </div>
              <el-progress
                :percentage="responseData.disbursement_utilization_percentage"
                :stroke-width="14"
                :status="
                  responseData.disbursement_utilization_percentage > 80 ? 'exception' : 'success'
                "
              ></el-progress>
            </div>

            <el-divider></el-divider>

            <div class="chart-section">
              <h4 class="section-title">Visualisasi Alokasi & Status Pengajuan (Juta Rp)</h4>
              <div ref="barChart" class="chart-container"></div>
            </div>

            <el-divider></el-divider>

            <el-row :gutter="16" class="metrics-grid">
              <el-col :xs="24" :sm="8">
                <div class="metric-box bg-light-blue">
                  <div class="metric-label">Total Company Limit</div>
                  <div class="metric-value text-blue">
                    {{ formatCurrency(responseData.company_limit) }}
                  </div>
                  <div class="metric-sub font-mono">
                    Beban Gaji: {{ responseData.salary_burden_percentage }}%
                  </div>
                </div>
              </el-col>

              <el-col :xs="24" :sm="8">
                <div class="metric-box bg-light-green">
                  <div class="metric-label">Max Balance Disbursement</div>
                  <div class="metric-value text-green">
                    {{ formatCurrency(responseData.max_balance_disbursement) }}
                  </div>
                  <div class="metric-sub font-mono">Batas Efektif Pencairan</div>
                </div>
              </el-col>

              <el-col :xs="24" :sm="8">
                <div class="metric-box bg-light-purple">
                  <div class="metric-label">Sisa Limit Pencairan</div>
                  <div class="metric-value text-purple">
                    {{ formatCurrency(responseData.remaining_disbursement_limit) }}
                  </div>
                  <div class="metric-sub font-mono">Sisa Kuota Tersedia</div>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import moment from 'moment';
import {
  INIT_2FA_HEAD,
  ACTIVATE_2FA_HEAD,
  ACTIVATE_2FA_HEAD_VEFIRY,
  INQ_HEAD,
  INQUIRY_HEAD,
  MY_PROFILE,
} from '@/store/modules/auth';
import emptyStateImage from '@/assets/images/undraw/empty-approval-history.svg';
import popupErrorMessages from '@/library/popup-error-messages';
import { GET_MYBENEFIT, GET_MYBENEFIT_DETAIL, ASSIGN_PACKAGE } from '@/store/modules/mybenefit';
import {
  DETAIL_COMPANIES,
  DETAIL_MYBEN_BY_COMPANY,
  GET_TOTAL_SALARY_COMPANIES,
  GET_FEATURES,
  GET_SETTING_POLICY,
  GET_PRODUCT_SETTING,
  GET_SETTING_COMPANY,
  UPDATE_EFFECTIVE_DATE,
  UPDATE_POLICY,
  UPDATE_PRODUCT_CONFIG,
  UPDATE_PAYROLL_DATE,
  GET_USAGE,
} from '@/store/modules/companies';
import { UPLOAD_IMAGE } from '@/store/modules/channel';
import base64File from '@/library/base64File';
import imageCompress from '@/library/vue-image-compression';

export default {
  name: 'ManageMybenefitFeatures',
  metaInfo: {
    title: 'Company Page',
  },
  data() {
    const periodLength = 12;
    const tenorOptions = [];
    for (let index = 1; index <= periodLength; index++) {
      tenorOptions.push({ label: index.toString(), value: index });
    }
    return {
      chartInstance: null,
      overlay: false,
      timerActive: false,
      countdownSeconds: 0,
      timerInterval: null,
      is_headrole: false,
      need_tfa: false,
      is_head_verified: false,
      is_head: false,
      is_otp_secret: false,
      is_active: false,
      otpArray: ['', '', '', '', '', ''],
      loading: { submit: false },
      isSendingOtp: false,
      modal: {
        contactNumber: '',
      },
      savedContactNumber: '',
      selectedRow: null,
      id: 0,
      showModalEffectiveDate: false,
      showModalCompanyLimit: false,
      showModalProductFeatures: false,
      showModalChart: false,
      selectedFeature: null,
      contactNumber: '',
      contractNumberModal: false,
      packet: '',
      total_salary: 0,
      total_employee: 0,
      adminFeeType: '',
      DataEwaTier: [],
      usage: null,
      detail_company_old: [],
      show: false,
      loading: {
        package_list: false,
        benefit_detail: false,
        assign_package: false,
        company_detail: false,
      },
      package_list: [],
      form_old: {
        test: 0,
        package_id: '',
        tenor: '',
        repayment_terms: '',
        loan_tracker_company_id: '',
        mybenefit_start_at: moment().format('YYYY-MM-DD'),
        is_enabled_ewa: false,
        is_enabled_reimburse: false,
        payoff_date: '',
        payroll_date: '',
        admin_fee: '',
        interest_fee: '',
        admin_fee_ewa: '',
        ewa_req_limit: '',
        is_enabled_gajianduluan: false,
        feature: {
          feature_name: '',
        },
        is_enabled_awa: true,
        is_enabled_gop: true,
        company_id: '',
        company_policy: {
          max_balance_disbursement: 0,
          salary_burden_percentage: 40,
          alert_method: 'email',
          total_limit_percentage: 100,
        },
      },
      datePickerStartOptions: {
        disabledDate: (date) => moment(date).isBefore(moment(), 'days'),
      },
      datePickerEndOptions: {
        disabledDate: (date) => moment(date).isBefore(moment(), 'days'),
      },
      playstore:
        'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US',
      appstore: 'https://apps.apple.com/us/app/google-authenticator/id388497605',
      qrcode: '',
      loader: null,
      loaderStack: 0,
      loading: {
        submit: false,
      },
      form: {
        is_fast_track: true,
        company_policy: {
          is_fast_track: true,
          pks_info: {
            number: '',
          },
        },
        code: '',
        data_image: '',
        image: null,
        image_base64: null,
        upload: {
          image: null,
        },
        pks_number: '',
        document_url: '',
        lock_reference_number: null,
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add(7, 'days').format('YYYY-MM-DD'),
        new_features: [
          {
            effective_date: {
              start_date: '',
              end_date: '',
            },
          },
        ],
        package_id: '',
        tenor: '',
        repayment_terms: '',
        force_full_limit_in: '',
        loan_tracker_company_id: '',
        mybenefit_start_at: moment().format('YYYY-MM-DD'),
        is_enabled_ewa: false,
        is_enabled_reimburse: false,
        payoff_date: '',
        payroll_date: '',
        admin_fee: '',
        interest_fee: '',
        admin_fee_ewa: '',
        ewa_req_limit: '',
        is_enabled_gajianduluan: false,
        early_repayment: 'full',
        deduction_type: 'upfront',
        type: '',
        minimum_request: 0,
        is_forced: 'optional',
        insurance_fee_awav2: 0,
        processing_fee_awav2: 0,
        early_repayment_awav2: 0,
        product_setting: {
          ewa_v2: {
            active: true,
            max_percentage: 30,
            contract_number: '',
            always_on: true,
            admin_fee_type: 'percentage',
            admin_fee_deduct: 'upfront',
            admin_fee: {
              base_percentage: 3.0,
              min_fee: 25000,
              min_percentage: 2.3,
            },
          },
          awa_v1: {
            active: true,
            max_percentage: 40,
            contract_number: '',
            admin_fee_type: 'percentage',
            admin_fee_deduct: 'upfront',
            admin_fee: {
              base_percentage: 3.0,
              min_fee: 25000,
              min_percentage: 2.3,
            },
            repayment_terms: [],
            force_full_limit_in: 0,
          },
          gop_v1: {
            active: true,
            max_percentage: 30,
            contract_number: '',
            admin_fee_type: 'percentage',
            repayment_terms: [],
          },
        },
        company_policy: {
          max_balance_disbursement: 0,
          salary_burden_percentage: 40,
          alert_method: 'email',
          total_limit_percentage: 100,
        },
        effective_date: {
          start_date: moment().format('YYYY-MM-DD'),
          end_date: moment().add(7, 'days').format('YYYY-MM-DD'),
        },
        features: [],
        is_enabled_awa: true,
        is_enabled_gop: true,
        company_id: '',
      },
      datePickerOptions: {},
      benefit_list: [],
      detail_company: [],
      setting_company: [],
      setting_policy: [],
      product_setting: [],
      features: [],
      new_features: [],
      salary: [],
      showModalCreatePackage: false,
      options: [],
      is_fast_track_options: [
        {
          label: 'Yes',
          value: 'true',
        },
        {
          label: 'No',
          value: 'false',
        },
      ],
      admin_fee_type_options: [
        {
          label: 'Percentage',
          value: 'percentage',
        },
        {
          label: 'Fixed',
          value: 'fix',
        },
      ],
      insurancefee_type_options: [
        {
          label: 'Force Checked',
          value: 'force_checked',
        },
        {
          label: 'Force Unchecked',
          value: 'force_unchecked',
        },
        {
          label: 'Optional',
          value: 'optional',
        },
      ],
      early_repayment_type_options: [
        {
          label: 'Full',
          value: 'full',
        },
        {
          label: 'Partial',
          value: 'partial',
        },
      ],
      deduction_type_options: [
        {
          label: 'Upfront',
          value: 'upfront',
        },
        {
          label: 'Backend',
          value: 'backend',
        },
      ],
      tenor_options: tenorOptions,
    };
  },
  async mounted() {
    const id = this.$route.params.id;
    this.loadCompanyDetail();
    this.loadTotalSalaryEmployeeList();
    this.loadSettingPolicy();
    // this.loadSetting()
    this.isHeadVerified();
    this.loadProfile();
    this.checkTimer();
  },
  beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  },
  computed: {
    responseData() {
      if (!this.usage) return {};
      return this.usage?.data?.data || this.usage?.data?.rows?.[0] || this.usage?.data || {};
    },
    formattedTime() {
      if (!this.countdownSeconds || this.countdownSeconds <= 0) {
        return '00:00';
      }
      const hours = Math.floor(this.countdownSeconds / 3600);
      const minutes = Math.floor((this.countdownSeconds % 3600) / 60);
      const seconds = this.countdownSeconds % 60;
      const pad = (num) => String(num).padStart(2, '0');
      if (hours > 0) {
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      }
      return `${pad(minutes)}:${pad(seconds)}`;
    },
    combinedCode() {
      return this.otpArray.join('');
    },
    isAdmin() {
      const userAccess = this.$store.getters.current_role;
      const roleName = userAccess?.role?.name;
      const isSuperAdmin = roleName === 'Super Admin';
      return isSuperAdmin;
    },
    myProfile() {
      return this.$store.getters.currentMyProfile;
    },
    combinedCode() {
      return this.otpArray.join('');
    },
    isAllMandatoryFilled() {
      const hasEffectiveDate = !!(this.form.start_date && this.form.end_date);
      const hasPayrollDate = !!(this.form.payoff_date && this.form.payroll_date);
      const hasLimitCompany = !!(
        this.form?.company_policy?.pks_info?.number &&
        this.form?.company_policy?.pks_info?.document_url
      );
      return hasEffectiveDate && hasPayrollDate && hasLimitCompany;
    },
    isCodeMandatoryFilled() {
      return this.is_head_verified === true && this.timerActive === true;
    },
    currentRole() {
      return this.$store.getters.current_role || {};
    },
    isOpsCompanyEditor() {
      const role = this.currentRole;
      return (
        // role.page_name === 'companies' &&
        // role.role?.name === 'OPS Team' &&
        role.can_create === true && role.can_edit === true
      );
    },
    isReadonlyPage() {
      return !this.isOpsCompanyEditor;
    },
    deductionTypeModel: {
      get() {
        return this.feature?.deduction_type || this.form.deduction_type;
      },
      set(value) {
        if (this.feature && this.feature.deduction_type !== undefined) {
          this.feature.deduction_type = value;
        } else {
          this.form.deduction_type = value;
        }
      },
    },
    minimumRequestModel: {
      get() {
        return this.feature?.minimum_request || this.form.minimum_request;
      },
      set(value) {
        if (this.feature && this.feature.minimum_request !== undefined) {
          this.feature.minimum_request = value;
        } else {
          this.form.minimum_request = value;
        }
      },
    },
    filteredProductFeatures() {
      return (this.form.product_features || []).filter((f) => f.name !== 'updated_by');
    },
    formattedMaxBalancee: {
      get() {
        return this.formatNumber(this.form.company_policy.max_balance_disbursement);
      },
      set(value) {
        this.form.company_policy.max_balance_disbursement =
          parseInt(this.parseFormattedNumber(value), 10) || 0;
      },
    },
    formattedPksNumber: {
      get() {
        return this.form?.company_policy?.pks_info?.number || '';
      },
      set(value) {
        if (this.form?.company_policy?.pks_info) {
          this.form.company_policy.pks_info.number = value;
        }
      },
    },
    formattedDocumentPksNumber: {
      get() {
        return this.form?.company_policy?.pks_info?.document_url || '';
      },
      set(value) {
        if (this.form?.company_policy?.pks_info) {
          this.form.company_policy.pks_info.document_url = value;
        }
      },
    },
    formattedTotalSalary: {
      get() {
        return this.formatNumber(this.total_salary);
      },
      set(value) {
        this.total_salary = parseInt(this.parseFormattedNumber(value), 10) || 0;
      },
    },
    rowTypes() {
      return [
        { label: 'Enabled', type: 'enabled' },
        { label: 'Version', type: 'version' },
        { label: 'Early Repayment Type', type: 'early_repayment' },
        { label: 'Deduction Type', type: 'deduction_type' },
        { label: 'Minimum Request', type: 'minimum_request' },
        { label: 'Limit Feature (%)', type: 'max_percentage' },
        { label: 'Min Percentage (%)', type: 'min_percentage' },
        // { label: 'Admin Fee (%)', type: 'admin_fee' },
        { label: 'Admin Fee', type: 'admin_fee' },
        { label: 'Min Fee', type: 'min_fee' },
        { label: 'Ewa Limit', type: 'ewa_limit' },
        { label: 'Ewa Request Limit', type: 'ewa_req_limit' },
        { label: 'Type', type: 'type' },
        { label: 'Full Limit (days)', type: 'days' },
        { label: 'Insurance Type', type: 'insurance_type' },
        { label: 'Insurance Fee', type: 'insurance_fee' },
        { label: 'Is Forced', type: 'is_forced' },
        { label: 'Processing Fee', type: 'processing_fee' },
        { label: 'Processing Fee Type', type: 'processing_fee_type' },
        { label: 'Tenor', type: 'tenor' },
      ];
    },
    isSubmitDisabled() {
      const features = this.form.product_features || [];
      const getActive = (name) => features.find((f) => f.name === name && f.active);
      const ewa = getActive('ewa_v2');
      const awa = getActive('awa_v1');
      const isValid = (f) => f && f.max_percentage && parseInt(f.max_percentage) > 0;
      if (ewa && awa) {
        return !(isValid(ewa) || isValid(awa));
      }
      if (ewa) return !isValid(ewa);
      if (awa) return !isValid(awa);

      return false;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
  methods: {
    handleMinFeeBlur(feature) {
      const MIN = 30000;
      const MAX = 100000;
      let currentValue = feature.admin_fee?.min_fee;
      if (currentValue === undefined || currentValue === null || currentValue < MIN) {
        feature.admin_fee.min_fee = MIN;
      } else if (currentValue > MAX) {
        feature.admin_fee.min_fee = MAX;
      }
    },
    handlePercentageInput(value) {
      if (value > 100) {
        this.form.company_policy.salary_burden_percentage = 100;
      } else if (value < 0) {
        this.form.company_policy.salary_burden_percentage = 0;
      }
    },
    initChart() {
      const chartDom = this.$refs.barChart;
      if (!chartDom) return;
      this.chartInstance = echarts.init(chartDom);
      const summary = this.responseData?.summary || {};
      // const usedCommitted = ((this.responseData?.used_committed || 0) / 1000000).toFixed(2);
      const onProcessAmount = ((summary.on_process?.total_amount || 0) / 1000000).toFixed(2);
      const usedCommitted = (
        (this.responseData?.summary?.committed?.total_amount || 0) / 1000000
      ).toFixed(2);
      const remainingLimit = (
        (this.responseData?.remaining_disbursement_limit || 0) / 1000000
      ).toFixed(2);
      const actualAmount = ((summary.actual?.total_amount || 0) / 1000000).toFixed(2);
      const onHoldAmount = ((summary.on_hold?.total_amount || 0) / 1000000).toFixed(2);
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: '{b}: <b>Rp {c} Juta</b>',
        },
        grid: {
          left: '3%',
          right: '5%',
          bottom: '12%',
          top: '15%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: [
            'On Process',
            'Sisa Limit\nPencairan',
            'Limit Digunakan\n(Committed)',
            'Actual\n(Disbursed)',
            'On Hold',
          ],
          axisLabel: { fontSize: 11, interval: 0 },
        },
        yAxis: {
          type: 'value',
          name: 'Nominal (Juta Rp)',
          splitLine: { lineStyle: { type: 'dashed' } },
        },
        series: [
          {
            name: 'Nominal (Juta Rp)',
            type: 'bar',
            barWidth: '35px',
            data: [
              { value: onProcessAmount, itemStyle: { color: '#f39c12' } },
              { value: remainingLimit, itemStyle: { color: '#27ae60' } },
              { value: usedCommitted, itemStyle: { color: '#d9534f' } },
              { value: actualAmount, itemStyle: { color: '#2980b9' } },
              { value: onHoldAmount, itemStyle: { color: '#7f8c8d' } },
            ],
            label: {
              show: true,
              position: 'top',
              formatter: 'Rp {c}M',
              fontSize: 11,
              fontWeight: 'bold',
            },
          },
        ],
      };

      this.chartInstance.setOption(option);
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    formatCurrency(value) {
      if (!value) return 'Rp 0';
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        maximumFractionDigits: 0,
      }).format(value);
    },
    getOtpDurationMs() {
      const hours = Number(process.env.VUE_APP_OTP_EXPIRATION_HOURS) || 2;
      return hours * 60 * 60 * 1000;
    },
    startNewTimer() {
      const durationMs = this.getOtpDurationMs();
      const expirationTime = Date.now() + durationMs;
      localStorage.setItem('timer', expirationTime.toString());
      this.startCountdown(durationMs / 1000);
    },
    checkTimer() {
      const savedExpiration = localStorage.getItem('timer');
      if (!savedExpiration) {
        this.timerActive = false;
        return;
      }
      const remaining = Math.ceil((parseInt(savedExpiration, 10) - Date.now()) / 1000);
      if (remaining > 0) {
        this.startCountdown(remaining);
      } else {
        localStorage.removeItem('timer');
        this.timerActive = false;
      }
    },
    startCountdown(secondsOrTimestamp) {
      this.timerActive = true;
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
      const expirationTimestamp =
        Number(secondsOrTimestamp) > 1e10
          ? Number(secondsOrTimestamp)
          : Date.now() + Number(secondsOrTimestamp) * 1000;
      const updateTimer = () => {
        const remaining = Math.ceil((expirationTimestamp - Date.now()) / 1000);
        if (remaining <= 0) {
          clearInterval(this.timerInterval);
          this.timerInterval = null;
          localStorage.removeItem('timer');
          this.timerActive = false;
          this.countdownSeconds = 0;
        } else {
          this.countdownSeconds = remaining;
        }
      };
      updateTimer();
      this.timerInterval = setInterval(updateTimer, 1000);
    },
    async onSubmit() {
      const codeString = String(this.combinedCode || '').trim();
      if (codeString.length < 6) {
        this.$message.error('Please enter a valid 6-digit code');
        return;
      }
      this.showLoader();
      this.loading.submit = true;
      try {
        const response = await this.$store.dispatch(ACTIVATE_2FA_HEAD_VEFIRY, { code: codeString });
        if (response.is_valid === true) {
          this.is_active = true;
          this.$message({
            title: 'Success',
            type: 'success',
            message: 'Successfully activate two-factor authentication',
          });
          const durationMs = this.getOtpDurationMs();
          const expirationTime = Date.now() + durationMs;
          localStorage.setItem('timer', expirationTime.toString());
          this.startCountdown(expirationTime);
        } else {
          this.is_active = true;
          this.$message.error('Invalid 2FA code. Please try again.');
        }
      } catch (err) {
        console.error('2FA Error:', err);
        this.is_active = false;
        popupErrorMessages(err?.response?.data).catch(() => {});
      } finally {
        this.loading.submit = false;
        this.hideLoader();
      }
    },
    handleOtpInput(event, index) {
      const value = event.target.value;
      if (value && index < 5) {
        this.$refs['otp' + (index + 1)][0].focus();
      }
    },
    handleOtpDelete(event, index) {
      if (!event.target.value && index > 0) {
        this.$refs['otp' + (index - 1)][0].focus();
      }
    },
    async loadProfile() {
      try {
        await this.$store.dispatch(MY_PROFILE);
        this.need_tfa = this.myProfile?.tfa_active === false;
        this.is_headrole = this.myProfile?.is_head_role === true;
        // if (this.need_tfa && this.is_headrole) {
        //   await this.isHeadVerified();
        // }
      } catch (error) {
        console.error('Error load profile:', error);
      }
    },
    async isHeadVerified() {
      this.showLoader();
      try {
        const response = await this.$store.dispatch(INQUIRY_HEAD);
        this.is_head_verified = response.is_active;
        // if (!this.is_head_verified && this.is_headrole == true) {
        //   this.generateQr();
        // }
      } catch (error) {
        console.error('Error:', error);
      } finally {
        this.hideLoader();
      }
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    OpenModalEffectiveDate() {
      this.showModalEffectiveDate = true;
    },
    OpenModalCompanyLimit() {
      this.showModalCompanyLimit = true;
    },
    OpenModalProductFeatures() {
      this.showModalProductFeatures = true;
    },
    async OpenModalChart() {
      this.showModalChart = true;
      await this.loadUsage();
      this.$nextTick(() => {
        this.initChart();
        window.addEventListener('resize', this.handleResize);
      });
    },
    handleProcessingFeeChange(feature) {
      console.log('fee:', feature.processing_fee.fee);
      console.log('type:', feature.processing_fee.type);
    },
    handleMinPercentageBlur(row) {
      if (
        row.min_percentage === undefined ||
        row.min_percentage === null ||
        row.min_percentage >= row.admin_fee
      ) {
        row.min_percentage = 2.3;
      }
    },
    async uploadImage() {
      this.company_id = parseInt(this.company_id);
      if (!this.file_tmp) return;
      try {
        const cleanBase64 = this.file_tmp.includes('base64,')
          ? this.file_tmp.split('base64,')[1]
          : this.file_tmp;

        const requestBody = {
          file_data: this.file_tmp,
          filename: 'document-pks.pdf',
          source: 'vdashboard',
          product: 'legal',
          category: 'company',
        };
        const response = await this.$store.dispatch(UPLOAD_IMAGE, {
          data: requestBody,
        });
        const { file_id, file_url } = response.data.rows;
        this.data_image = { file_id, file_url };
        this.file_tmp = '';
        this.$message({
          title: 'Success',
          type: 'success',
          message: 'Upload success created',
        });

        this.getList();
      } catch (err) {
        console.error('Upload Image Error:', err.response?.data || err.message);
        popupErrorMessages(err.response?.data);
      }
    },
    async onChangeFile(event, target) {
      if (this.form.upload[target]) {
        try {
          const compressed = await imageCompress(this.form.upload[target]);
          this.form.upload[`${target}_base64`] = await base64File(compressed);
          this.file_tmp = this.form.upload[`${target}_base64`];
          await this.uploadImage(compressed);
        } catch (error) {
          console.error('Processing error:', error);
        }
      }
    },
    // LIST PACKAGE
    async loadMyBenefitList() {
      this.loading.package_list = true;
      await this.$store.dispatch(GET_MYBENEFIT).then((response) => {
        this.package_list = response.rows;
        this.loadBenefitDetail();
      });
      this.loading.package_list = false;
    },
    async handlerBtnSubmitEffective() {
      this.loading.package_list = true;
      await this.$store.dispatch(GET_MYBENEFIT).then((response) => {
        this.package_list = response.rows;
        this.loadBenefitDetail();
      });
      this.loading.package_list = false;
    },
    // LIST PACKAGE BY ID
    async loadBenefitDetail() {
      if (!this.form_old.package_id) {
        return;
      }
      this.loading.benefit_detail = true;
      await this.$store
        .dispatch(GET_MYBENEFIT_DETAIL, {
          id: this.form_old.package_id,
        })
        .then(() => {
          this.benefit_list = this.$store.getters.benefit_list;
        });
      this.loading.benefit_detail = false;
    },
    // LOAD SETTING
    // async loadSetting() {
    //   this.loading.benefit_detail = true;
    //   await this.$store.dispatch(DETAIL_MYBEN_BY_COMPANY, {
    //       id: this.$route.params.id,
    //     }).then(() => {
    //       this.detail_company_old = this.$store.getters.myben_company;
    //     });
    //   this.loading.benefit_detail = false;
    // },
    // PRODUCT SETTING
    async loadProductSetting() {
      this.loading.benefit_detail = true;
      await this.$store
        .dispatch(GET_PRODUCT_SETTING, {
          id: this.$route.params.id,
        })
        .then(() => {
          this.detail_company = this.$store.getters.product_setting;
        });
      this.loading.benefit_detail = false;
    },
    // SETTING POLICY
    async loadSettingPolicy() {
      this.loading.benefit_detail = true;
      try {
        const response = await this.$store.dispatch(GET_SETTING_POLICY, {
          id: this.$route.params.id,
        });
        this.setting_policy = response?.data?.company_policy?.updated_by;
      } catch (error) {
        console.error(error);
      }
      this.loading.benefit_detail = false;
    },
    // FEATURES
    async loadFeatures() {
      this.loading.benefit_detail = true;
      await this.$store.dispatch(GET_FEATURES, { id: this.$route.params.id }).then(() => {
        this.detail_company = this.$store.getters.features;
      });
      this.loading.benefit_detail = false;
    },
    async loadUsage() {
      this.loading.benefit_detail = true;
      try {
        await this.$store.dispatch(GET_USAGE, { id: this.$route.params.id });
        this.usage = this.$store.getters.usage;
      } catch (error) {
      } finally {
        this.loading.benefit_detail = false;
      }
    },
    // DETAIL COMPANIES
    async loadCompanyDetailOld() {
      this.loading.company_detail = true;
      await this.$store
        .dispatch(DETAIL_COMPANIES, {
          id: this.$route.params.id,
        })
        .then(({ data }) => {
          this.form_old = {
            package_id: data.mybenefit_package_id === 0 ? '' : data.mybenefit_package_id,
            tenor: '',
            repayment_terms: '',
            loan_tracker_company_id: data.loan_tracker_company_id ?? '',
            mybenefit_start_at: data.mybenefit_package_start_at
              ? moment(data.mybenefit_package_start_at).format('YYYY-MM-DD')
              : '',
            is_enabled_ewa: data.is_enabled_ewa ?? false,
            is_enabled_reimburse: data.is_enabled_reimburse ?? false,
            is_enabled_gajianduluan: data.is_enabled_gajianduluan ?? false,
            is_enabled_awa: data.is_enabled_awa ?? false,
            is_enabled_gop: data.is_enabled_gop ?? false,
            payoff_date: data.setting?.payoff_date ?? '',
            payroll_date: data.setting?.payroll_date ?? '',
            admin_fee: data.company_loan_rate?.admin_fee_rate ?? '',
            interest_fee: data.company_loan_rate?.interest_rate ?? '',
            admin_fee_ewa: data.setting?.admin_fee_ewa ?? '',
            ewa_req_limit: data.setting?.ewa_req_limit ?? '',
            // company_id: data.id ?? '',
            company_id: this.$route.params.id,
            feature: {
              feature_name: data.feature?.feature_name ?? '',
            },
            company_policy: {
              max_balance_disbursement: data.setting?.company_policy?.max_balance_disbursement ?? 0,
              salary_burden_percentage: data.setting?.company_policy?.salary_burden_percentage ?? 0,
              alert_method: data.setting?.company_policy?.alert_method ?? '',
              total_limit_percentage: data.setting?.company_policy?.total_limit_percentage ?? 100,
            },
          };
          this.DataEwaTier = data.setting?.ewa_tier ?? [];
          this.loadBenefitDetail();
        })
        .catch((err) => {});

      this.loading.company_detail = false;
    },
    // GET TOTAL SALARY COMPANIES
    async loadTotalSalaryEmployeeList() {
      this.loading.company_detail = true;
      try {
        const result = await this.$store.dispatch(GET_TOTAL_SALARY_COMPANIES, {
          id: this.$route.params.id,
        });
        this.total_salary = result?.data?.total_salary ?? 0;
        this.total_employee = result?.data?.total_employee ?? 0;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading.company_detail = false;
      }
    },
    // GET DETAIL_MYBEN_BY_COMPANY
    async loadCompanyDetail() {
      try {
        this.loading.company_detail = true;
        const [settingRes, companyRes] = await Promise.all([
          this.$store.dispatch(DETAIL_MYBEN_BY_COMPANY, { id: this.$route.params.id }),
          this.$store.dispatch(GET_SETTING_COMPANY, { id: this.$route.params.id }),
        ]);
        // this.is_active = settingRes?.data?.rows?.[0]?.updated_by?.tfa_active ?? false;
        // this.is_otp_secret = settingRes?.data?.rows?.[0]?.updated_by?.totp_secret ?? '';
        const getFeatureKey = (item) => {
          const feature = item?.feature || {};
          const label = feature.feature_name;
          const v = feature.version || feature.feature_version;

          if (label === 'Earn Wage Access' && v === 'v1') return 'ewa_v1';
          if (label === 'Earned Wage Access' && v === 'v2') return 'ewa_v2';
          if (label === 'AWA V2' && v === 'v2') return 'awa_v2';
          if (label === 'Advanced Wage Access' && v === 'v1') return 'awa_v1';
          if (label === 'Ownership Program') return 'gop_v1';
          if (label === 'Reimbursement') return 'reimbursement_v1';
          if (label === 'WPS') return 'wps';
          if (label === 'wps testing') return 'wps_setting_v1';
          return feature.feature_slug || 'unknown_feature';
        };
        const masterFeatures = this.$store.getters.myben_company?.rows || [];
        const companyData = companyRes?.data || {};
        const productSetting = companyData.product_setting || {};

        const mappedProductSetting = masterFeatures.map((item) => {
          const featureKey = getFeatureKey(item);
          const companyValue = productSetting[featureKey] || {};

          let insuranceFee = companyValue.insurance_fee;
          if (featureKey === 'awa_v2') {
            insuranceFee = {
              ...(companyValue.insurance_fee || {}),
              is_forced: companyValue.insurance_fee?.is_forced || 'optional',
            };
          }
          return {
            ...companyValue,
            ...item,
            ...item.feature,
            name: featureKey,
            active: item.is_enabled ?? false,
            insurance_fee: insuranceFee,
            payoff_date: item.payoff_date,
            payroll_date: item.payroll_date,
          };
        });
        this.form = {
          ...this.form,
          new_features: JSON.parse(JSON.stringify(companyData)),
          new_admin_fee_ewa: companyData.admin_fee_ewa,
          new_payoff_date: companyData.payoff_date,
          new_payroll_date: companyData.payroll_date,
          ewa_tier: companyData.ewa_tier ?? [],
          // company_policy: companyData.company_policy ?? {},
          company_policy: {
            ...companyData.company_policy,
            pks_info: {
              number: companyData.company_policy?.pks_info?.number ?? '',
              document_url: companyData.company_policy?.pks_info?.document_url ?? '',
            },
          },
          product_features: mappedProductSetting,
          payoff_date: companyData.payoff_date,
          payroll_date: companyData.payroll_date,
        };
        await this.loadBenefitDetail();
      } catch (err) {
        console.error('Error merging master version and settings:', err);
      } finally {
        this.loading.company_detail = false;
      }
    },
    async doUpdateEffectiveDate() {
      this.$confirm(
        'You will update the Effective Date. Make sure you have input the data correctly. Continue?',
        'Confirmation',
        {
          type: 'info',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              done();
              const requestBody = {
                start_date:
                  this.form?.new_features?.effective_date?.start_date || this.form.start_date,
                end_date: this.form?.new_features?.effective_date?.end_date || this.form.end_date,
              };
              const id = this.$route.params.id;
              await this.$store
                .dispatch(UPDATE_EFFECTIVE_DATE, { id, data: requestBody })
                .then(() => {
                  this.$message({
                    title: 'Success',
                    type: 'success',
                    message: 'Effective Date Updated',
                  });
                  // this.loadMyBenefitListRevamp();
                  // this.onHide();
                })
                .catch((err) => {
                  popupErrorMessages(err.response.data);
                });
              return;
            }
            done();
          },
        }
      ).catch(() => {});
    },
    async doUpdatePayrollDate() {
      this.$confirm(
        'You will update the Payroll Date. Make sure you have input the data correctly. Continue?',
        'Confirmation',
        {
          type: 'info',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              done();
              const requestBody = {
                payoff_date: `${this.form.payoff_date}`,
                payroll_date: `${this.form.payroll_date}`,
              };
              const id = this.$route.params.id;
              await this.$store
                .dispatch(UPDATE_PAYROLL_DATE, { id, data: requestBody })
                .then(() => {
                  this.$message({
                    title: 'Success',
                    type: 'success',
                    message: 'Payroll Date Updated',
                  });
                  // this.loadMyBenefitListRevamp();
                  // this.onHide();
                })
                .catch((err) => {
                  popupErrorMessages(err.response.data);
                });
              return;
            }
            done();
          },
        }
      ).catch(() => {});
    },
    async doUpdatePolicy() {
      const maxBalance = this.form.company_policy?.max_balance_disbursement;
      const pksNumber = this.form.company_policy?.pks_info?.number;
      const docUrl = this.data_image?.file_url || this.form.company_policy?.pks_info?.document_url;

      if (!maxBalance || !pksNumber || !docUrl) {
        let missingFields = [];
        if (!maxBalance) missingFields.push('Max Balance Disbursement');
        if (!pksNumber) missingFields.push('PKS Number');
        if (!docUrl) missingFields.push('PKS Document');
        this.$message({
          type: 'error',
          message: 'Field Mandatory: ' + missingFields.join(', ') + ' must be filled!',
          duration: 5000,
          showClose: true,
        });
        return;
      }
      this.$confirm(
        'You will update the Policy. Make sure you have input the data correctly. Continue?',
        'Confirmation',
        {
          confirmButtonText: 'Yes, Update',
          cancelButtonText: 'Cancel',
          type: 'info',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              const requestBody = {
                max_balance_disbursement: Number(maxBalance),
                salary_burden_percentage: this.form.company_policy.salary_burden_percentage,

                alert_method: 'email',
                total_limit_percentage: 100,
                pks_info: {
                  number: pksNumber,
                  document_url: docUrl,
                },
                is_fast_track: this.form.company_policy.is_fast_track,
              };
              const id = this.$route.params.id;
              try {
                await this.$store.dispatch(UPDATE_POLICY, { id, data: requestBody });
                this.$message({
                  type: 'success',
                  message: 'Policy Updated Successfully',
                });
                done();
              } catch (err) {
                if (err.response && err.response.data) {
                  popupErrorMessages(err.response.data);
                } else {
                  this.$message.error('Something went wrong. Please try again.');
                }
              } finally {
                this.getList();
                this.loadBenefitDetail();
                this.loadProductSetting();
                this.loadSettingPolicy();
                this.loadFeatures();
                this.loadCompanyDetailOld();
                this.loadCompanyDetail();
                instance.confirmButtonLoading = false;
              }
            } else {
              done();
            }
          },
        }
      ).catch(() => {
        console.log('Update cancelled by user');
      });
    },
    async doUpdateProductSetting() {
      this.$confirm(
        'You will update the Product Setting. Make sure you have input the data correctly. Continue?',
        'Confirmation',
        {
          type: 'info',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              done();
              const excludedFeatures = [
                'null_v1',
                'gadun_v1',
                'updated_by',
                'wps',
                'wps_setting_v1',
                'reimbursement_v1',
              ];
              const baseExcludedFields = [
                'id',
                'company_id',
                'feature_id',
                'enabled_at',
                'disabled_at',
                'updated_by',
                'created_at',
                'updated_at',
                'feature',
                'config',
                'feature_name',
                'feature_slug',
                'feature_asset',
                'feature_color',
                'feature_deeplink',
                'feature_is_new',
                'feature_is_maintenance',
                'feature_is_coming',
                'feature_status',
                'feature_description',
                'feature_info',
                'feature_tnc',
                'feature_platform',
                'feature_sort_order',
                'feature_icon',
                'feature_category',
                'feature_version',
                'feature_minimum_app_version',
              ];
              const excludedFields = {
                ewa_v2: [
                  ...baseExcludedFields,
                  'repayment_terms',
                  'insurance_fee_type',
                  'insurance_fee',
                  'processing_fee',
                  'processing_fee_type',
                  'is_enabled',
                  '_disabled',
                ],
                awa_v1: [...baseExcludedFields, 'is_enabled', '_disabled'],
                awa_v2: [...baseExcludedFields, 'is_enabled', '_disabled'],
                gop_v1: [
                  ...baseExcludedFields,
                  'is_enabled',
                  '_disabled',
                  'force_full_limit_in',
                  'admin_fee',
                  'admin_fee_deduct',
                  'always_on',
                ],
              };
              const savedContractNumber = localStorage.getItem('contactNumber') || '-';

              // Helper logic for setting min_fee conditionally
              const getMinFee = (admin_fee) => {
                const isFastTrack = Boolean(this.form?.company_policy?.is_fast_track);
                return isFastTrack ? admin_fee?.min_fee ?? 30000 : 0;
              };

              const transformers = {
                awa_v2: (data) => {
                  const admin_fee = data.admin_fee || {};
                  const insurance_fee = data.insurance_fee || {};
                  const processing_fee = data.processing_fee || {};
                  return {
                    active: data.active,
                    max_percentage: Math.min(100, Math.max(70, Number(data.max_percentage) || 70)),
                    contract_number: this.form?.company_policy?.pks_info?.number || '-',
                    repayment_terms: data.repayment_terms,
                    deduction_type: data.deduction_type ?? this.form.deduction_type,
                    minimum_request: data.minimum_request ?? this.form.minimum_request,
                    max_balance: data.max_balance,
                    admin_fee: {
                      base_percentage: admin_fee.base_percentage || 3.0,
                      min_fee: admin_fee.min_fee || 0,
                      min_percentage: admin_fee.min_percentage || 2.3,
                      type: admin_fee.type || 'percentage',
                    },
                    insurance_fee: {
                      fee: insurance_fee.fee || 0,
                      type: insurance_fee.type || 'percentage',
                      is_forced: insurance_fee.is_forced || 'force_checked',
                    },
                    processing_fee: {
                      fee: processing_fee.fee || 3.0,
                      type: processing_fee.type || 'percentage',
                    },
                    early_repayment: {
                      type: data.early_repayment?.type || 'full',
                    },
                  };
                },
                ewa_v2: (data) => {
                  const admin_fee = data.admin_fee || {};
                  const insurance_fee = data.insurance_fee || {};
                  const processing_fee = data.processing_fee || {};
                  return {
                    active: data.active,
                    max_percentage: Math.min(100, Math.max(70, Number(data.max_percentage) || 70)),
                    contract_number: this.form?.company_policy?.pks_info?.number || '-',
                    repayment_terms: data.repayment_terms,
                    minimum_request: data.minimum_request ?? this.form.minimum_request,
                    max_balance: data.max_balance,
                    admin_fee: {
                      base_percentage: admin_fee.base_percentage || 3.0,
                      min_fee: getMinFee(admin_fee),
                      min_percentage: admin_fee.min_percentage || 2.3,
                      type: admin_fee.type || 'percentage',
                    },
                    insurance_fee: {
                      fee: insurance_fee.fee || 0,
                      type: insurance_fee.type || 'percentage',
                      is_forced: insurance_fee.is_forced || 'force_checked',
                    },
                    processing_fee: {
                      fee: processing_fee.fee || 3.0,
                      type: processing_fee.type || 'percentage',
                    },
                    admin_fee_deduct: 'upfront',
                    admin_fee_type: 'percentage',
                    always_on: true,
                    force_full_limit_in: 10,
                  };
                },
                ewa_v1: (data) => {
                  return {
                    active: data.active,
                    always_on: data.always_on,
                    force_full_limit_in: 1,
                    ewa_limit: data.ewa_limit || 2500,
                    admin_fee_ewa: data.admin_fee_ewa || 1000,
                    ewa_req_limit: data.ewa_req_limit || 2000,
                    ewa_tier: [{}],
                  };
                },
                gop_v1: (data) => {
                  return {
                    active: data.active,
                    contract_number: this.form?.company_policy?.pks_info?.number || '-',
                    admin_fee_type: 'percentage',
                  };
                },
              };
              const requestBody = Object.fromEntries(
                this.form.product_features
                  .filter((item) => !excludedFeatures.includes(item.name))
                  .map((item) => {
                    const { name, ...rest } = item;
                    let newValue = { ...rest };
                    if (transformers[name]) {
                      newValue = transformers[name](newValue);
                    }
                    if (excludedFields[name]) {
                      excludedFields[name].forEach((field) => {
                        delete newValue[field];
                      });
                    }
                    return [name, newValue];
                  })
              );
              const id = this.$route.params.id;
              try {
                await this.$store.dispatch(UPDATE_PRODUCT_CONFIG, {
                  id,
                  data: requestBody,
                });
                this.$message({
                  title: 'Success',
                  type: 'success',
                  message: 'Product Config Updated',
                });
              } catch (err) {
                const responseData = err.response?.data;
                const errorList = responseData?.error?.errors;
                if (Array.isArray(errorList) && errorList.length > 0) {
                  const validationMessages = errorList
                    .filter((item) => item && item.message)
                    .map((item) => item.message);

                  if (validationMessages.length > 0) {
                    const formattedList = validationMessages
                      .map((msg) => `<li style="margin-bottom: 4px;">${msg}</li>`)
                      .join('');

                    this.$message({
                      type: 'error',
                      dangerouslyUseHTMLString: true,
                      message: `<ul style="padding-left: 16px; margin: 0; text-align: left;">${formattedList}</ul>`,
                      duration: 5000,
                      showClose: true,
                    });
                    return;
                  }
                }
                popupErrorMessages(responseData);
              }
              return;
            }
            done();
          },
        }
      ).catch(() => {});
    },
    submitCN(feature) {
      this.$nextTick(() => {
        if (!this.modal.contactNumber) {
          this.$message.error('Contract Number is required.');
          return;
        }
        localStorage.setItem('contactNumber', this.modal.contactNumber);
        this.contractNumberModal = false;
        this.selectedFeature = feature;
        this.processFeatureToggleLogic(feature);
      });
    },
    cancelCN() {
      this.contractNumberModal = false;
      if (this.selectedFeature) {
        this.selectedFeature.is_enabled = false;
        const index = this.form.features.findIndex((f) => f.id === this.selectedFeature.id);
        if (index !== -1) {
          this.$set(this.form.features, index, { ...this.selectedFeature });
        }
      }
    },
    formatNumber(value) {
      if (typeof value !== 'string') {
        value = String(value);
      }
      value = value.replace(/[^0-9.]/g, '');
      const parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    parseFormattedNumber(value) {
      return value.replace(/,/g, '');
    },
    handlerSelectPackage() {
      this.loadBenefitDetail();
    },
    handleProcessingFeeBlur(row) {
      const isFix = row.processing_fee_type === 'fix';
      const min = 0;
      const max = isFix ? 100000 : 100;
      let value = Number(row.processing_fee) || 0;
      if (value < min) value = min;
      if (value > max) value = max;
      if (!isFix) {
        value = Math.round(value * 10) / 10;
      } else {
        value = Math.round(value);
      }
      row.processing_fee = value;
    },
    handleAdminFeeBlur(row) {
      const min = 3;
      if (!row.admin_fee || row.admin_fee < min) {
        row.admin_fee = min;
      }
    },
    handleAdminFee(row) {
      if (row.admin_fee < 3 || isNaN(row.admin_fee)) {
        row.admin_fee = 3;
      }
    },
    handleMinBasePercentageFee(row) {
      if (row.min_percentage !== '' && row.min_percentage < 2.3) {
        row.min_percentage = 2.3;
      }
    },
    // AWA V2
    handleMaxPercentageInput(feature) {
      if (!feature?.name) return;

      const [slug, version] = feature.name.split('_');
      if (slug === 'awa' && version === 'v2') {
        const min = 70;
        const max = 100;
        if (feature.max_percentage < min) {
          feature.max_percentage = min;
        } else if (feature.max_percentage > max) {
          feature.max_percentage = max;
        }
        return;
      }
      const limit = this.getMaxLimit(feature);
      if (feature.max_percentage > limit) {
        feature.max_percentage = limit;
      } else if (feature.max_percentage < 0) {
        feature.max_percentage = 0;
      }
    },
    getMaxLimit(row) {
      if (!row?.active || !row?.name) return 0;
      const [rowSlug, rowVersion] = row.name.split('_');
      if (rowSlug === 'awa' && rowVersion === 'v2') {
        return 100;
      }
      const relevantKeys = ['ewa:v2', 'gop:v1', 'awa:v1'];
      const totalOthers = this.form.product_features.reduce((sum, item) => {
        if (!item?.active || !item?.name) return sum;
        const [slug, version] = item.name.split('_');
        const key = `${slug}:${version}`;
        const currentKey = `${rowSlug}:${rowVersion}`;
        const isRelevant = key !== currentKey && relevantKeys.includes(key);
        if (isRelevant) {
          return sum + parseInt(item.max_percentage || 0);
        }
        return sum;
      }, 0);
      const remaining = Math.max(0, 100 - totalOthers);
      const isEwa = rowSlug === 'ewa' && rowVersion === 'v2';
      if (isEwa) {
        return Math.min(100, remaining);
      }
      return remaining;
    },
    shouldShowFeeType(row) {
      if (!row?.active || !row?.name) return false;
      const [slug] = row.name.split('_');
      return ['awa', 'gop'].includes(slug);
    },
    shouldShowTenor(row) {
      if (!row?.active || !row?.name) return false;
      const [slug] = row.name.split('_');
      return ['awa', 'gop'].includes(slug);
    },
    shouldProcessing(row) {
      if (!row?.active || !row?.name) return false;
      const [slug] = row.name.split('_');
      return ['awa'].includes(slug);
    },
    shouldShowMP(row) {
      if (!row?.active || !row?.name) return false;
      const [slug, version] = row.name.toLowerCase().split('_');
      return (
        // (slug === 'ewa' && (version === 'v2' || version === 'v1')) ||
        (slug === 'ewa' && version === 'v2') ||
        (slug === 'awa' && (version === 'v1' || version === 'v2')) ||
        (slug === 'gop' && version === 'v1')
      );
    },
    shouldShowMinFee(row) {
      if (!row?.active || !row?.name) return false;
      const [slug, version] = row.name.toLowerCase().split('_');
      return slug === 'ewa' && version === 'v2';
    },
    shouldShowAF(row) {
      if (!row?.active || !row?.name) return false;
      const [slug, version] = row.name.split('_');
      return (
        (slug === 'ewa' && version === 'v2') ||
        (slug === 'awa' && ['v1', 'v2'].includes(version)) ||
        (slug === 'gop' && version === 'v1')
      );
    },
    shouldShowLimit(row) {
      if (!row?.active || !row?.name) return false;
      const [slug, version] = row.name.split('_');
      return slug === 'ewa' && version === 'v1';
    },
    shouldShowAwav2(row) {
      if (!row?.active || !row?.name) return false;
      const [slug, version] = row.name.split('_');
      return slug === 'awa' && version === 'v2';
    },
    shouldShowDays(row) {
      if (!row?.active || !row?.name) return false;
      const [slug, version] = row.name.split('_');
      return slug === 'ewa' && version === 'v2';
    },
    shouldShowMinimumReq(row) {
      if (!row?.active || !row?.name) return false;
      const [slug, version] = row.name.split('_');
      return (
        (slug === 'ewa' && ['v1', 'v2'].includes(version)) ||
        (slug === 'awa' && ['v1', 'v2'].includes(version))
      );
    },
    handleFeatureToggle(feature) {
      this.modal.contactNumber = '';
      this.selectedFeature = feature;
      const featureKey = feature.name;
      const featureWithContract = this.form.product_features.find((f) => {
        return f.contract_number && f.contract_number[featureKey];
      });
      let contractNumber = '-';
      if (featureWithContract) {
        contractNumber = featureWithContract.contract_number[featureKey]?.contract_number ?? '-';
      }
      this.modal.contractNumber = contractNumber;
      this.savedContactNumber = contractNumber;
      if (feature.active) {
        this.contractNumberModal = true;
        return;
      }
      this.processFeatureToggleLogic(feature);
    },
    onContractNumberConfirmed() {
      const contact = this.modal.contactNumber?.trim();
      if (!contact) {
        this.$message.error('Contact number is required.');
        this.contractNumberModal = false;
        if (this.selectedFeature) {
          this.$nextTick(() => {
            this.selectedFeature.is_enabled = false;
            const index = this.form.product_features.findIndex(
              (f) => f.name === this.selectedFeature.name
            );
            if (index !== -1) {
              this.$set(this.form.product_features, index, { ...this.selectedFeature });
            }
          });
        }
        return;
      }
      this.contractNumberModal = false;
      this.processFeatureToggleLogic(this.selectedFeature);
    },
    processFeatureToggleLogic(feature) {
      const [slug, version] = feature.name.split('_');
      const isEwa = slug === 'ewa';
      const isEwaV1 = isEwa && version === 'v1';
      const isEwaV2 = isEwa && version === 'v2';
      this.form.product_features.forEach((f) => {
        f._disabled = false;
      });
      if (isEwaV1 && feature.active) {
        const ewaV2 = this.form.product_features.find((f) => f.name === 'ewa_v2');

        if (ewaV2) {
          ewaV2._disabled = true;
          ewaV2.active = false;
        }
        this.form.product_features.forEach((f) => {
          const [fSlug] = f.name.split('_');

          if (fSlug !== 'ewa' && fSlug !== 'gadun' && fSlug !== 'reimburse') {
            f._disabled = true;
            f.active = false;
          }
        });
      }
      if (isEwaV1 && !feature.active) {
        this.form.product_features.forEach((f) => {
          f._disabled = false;
        });
      }
      if (isEwaV2 && feature.active) {
        const ewaV1 = this.form.product_features.find((f) => f.name === 'ewa_v1');

        if (ewaV1) {
          ewaV1._disabled = true;
          ewaV1.active = false;
        }
      }
      if (isEwaV2 && !feature.active) {
        const ewaV1 = this.form.product_features.find((f) => f.name === 'ewa_v1');

        if (ewaV1) {
          ewaV1._disabled = false;
        }
      }
      if (slug === 'ewa') this.form.is_enabled_ewa = feature.active;
      if (slug === 'reimburse') this.form.is_enabled_reimburse = feature.active;
      if (slug === 'gadun') this.form.is_enabled_gajianduluan = feature.active;
      this.form.name = this.form.product_features.filter((f) => f.active).map((f) => f.name);
    },
  },
  created() {
    for (let i = 1; i <= 31; i++) {
      this.options.push(i);
    }
  },
};
</script>
<style>
.tag-gold {
  background-color: #fcc200;
  color: #fff;
  font-weight: 600;
}
.tag-bronze {
  background-color: #cd7f32;
  color: #fff;
  font-weight: 600;
}
.history-panel {
  position: sticky;
  top: 20px;
  max-height: 85vh;
  overflow-y: auto;
}
.readonly-page {
  pointer-events: none;
  opacity: 0.95;
}

.readonly-page .card {
  pointer-events: auto;
}

.readonly-page input,
.readonly-page textarea,
.readonly-page select,
.readonly-page button,
.readonly-page .el-input,
.readonly-page .el-select,
.readonly-page .el-button,
.readonly-page .el-date-editor,
.readonly-page .el-switch {
  pointer-events: none !important;
}

/* gray style */
.readonly-page .el-input__inner,
.readonly-page .el-textarea__inner,
.readonly-page .el-select .el-input__inner,
.readonly-page .el-date-editor .el-input__inner,
.readonly-page .el-input-number__decrease,
.readonly-page .el-input-number__increase,
.readonly-page .el-button,
.readonly-page .el-switch__core,
.readonly-page .el-tag,
.readonly-page .form-control,
.readonly-page .custom-select {
  background-color: #e9ecef !important;
  border-color: #d6d8db !important;
  color: #7d776c !important;
  cursor: not-allowed !important;
}

/* primary button gray */
.readonly-page .el-button--primary {
  background-color: #c0c4cc !important;
  border-color: #c0c4cc !important;
  color: #ffffff !important;
}

/* switch gray */
.readonly-page .el-switch.is-checked .el-switch__core {
  background-color: #c0c4cc !important;
  border-color: #c0c4cc !important;
}

.tag-gold {
  background-color: #fcc200;
  color: #fff;
  font-weight: 600;
}
.tag-bronze {
  background-color: #cd7f32;
  color: #fff;
  font-weight: 600;
}
.history-panel {
  position: sticky;
  top: 20px;
  max-height: 85vh;
  overflow-y: auto;
}

.product-features-wrapper {
  position: relative;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.product-features-wrapper.is-locked .card {
  filter: blur(4px) grayscale(0.8);
  opacity: 0.5;
  pointer-events: none;
  user-select: none;
}

.lock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
}

.lock-message {
  position: relative;
  z-index: 11;
  max-width: 400px;
  padding: 2.5rem;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
  transform: translateY(-20px);
}

.el-table th.el-table__cell {
  background-color: #f8f9fa !important;
  color: #333 !important;
  font-weight: bold;
}

.lock-message .el-input__inner {
  border-color: #dcdfe6;
  background-color: #fcfcfc;
}

.lock-message .el-input__inner:focus {
  border-color: #409eff;
  background-color: #fff;
}

.fade-scale-leave-active {
  transition: all 0.5s ease;
}
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(1.1);
  filter: blur(10px);
}

.max-w-md {
  animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* new */
.company-limit-dashboard {
  max-width: 100%;
  margin: 20px auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.icon-title {
  margin-right: 8px;
  color: #409eff;
}

.usage-progress-section {
  margin-bottom: 15px;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 13px;
  color: #606266;
}

.sub-info {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}

.font-bold {
  font-weight: bold;
}
.font-mono {
  font-family: monospace;
}

.metrics-grid .metric-box {
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.bg-light-blue {
  background-color: #f0f7ff;
  border: 1px solid #d0e5ff;
}
.bg-light-green {
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
}
.bg-light-purple {
  background-color: #f8f2ff;
  border: 1px solid #ebd8ff;
}

.text-blue {
  color: #409eff;
}
.text-green {
  color: #67c23a;
}
.text-purple {
  color: #8e44ad;
}
.text-teal {
  color: #16a085;
}
.text-orange {
  color: #e67e22;
}
.text-gray {
  color: #7f8c8d;
}

.metric-label {
  font-size: 12px;
  color: #606266;
  margin-bottom: 4px;
}

.metric-value {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 4px;
}

.metric-sub {
  font-size: 11px;
  color: #909399;
}

.section-title {
  font-size: 14px;
  margin-bottom: 12px;
  color: #303133;
}

.summary-card {
  border-radius: 6px;
  background-color: #fafafa;
}

.summary-status {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
}

.summary-amount {
  font-size: 16px;
  font-weight: bold;
  color: #2c3e50;
}

.summary-count {
  font-size: 11px;
  color: #95a5a6;
  margin-top: 2px;
}

/* new */
.company-limit-dashboard {
  max-width: 950px;
  margin: 20px auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.icon-title {
  margin-right: 8px;
  color: #409eff;
}

.chart-section {
  margin: 10px 0;
}

.chart-container {
  width: 100%;
  height: 320px;
}

.section-title {
  font-size: 14px;
  margin-bottom: 15px;
  color: #303133;
}

.metrics-grid .metric-box {
  padding: 14px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.bg-light-blue {
  background-color: #f0f7ff;
  border: 1px solid #d0e5ff;
}
.bg-light-green {
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
}
.bg-light-purple {
  background-color: #f8f2ff;
  border: 1px solid #ebd8ff;
}

.text-blue {
  color: #409eff;
}
.text-green {
  color: #67c23a;
}
.text-purple {
  color: #8e44ad;
}

.metric-label {
  font-size: 12px;
  color: #606266;
  margin-bottom: 4px;
}

.metric-value {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 4px;
}

.metric-sub {
  font-size: 11px;
  color: #909399;
}
</style>
